import { render } from "./NumberWidgetParams.vue?vue&type=template&id=6616591b"
import script from "./NumberWidgetParams.vue?vue&type=script&lang=js"
export * from "./NumberWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script